<template>
  <div>
    <v-timeline
      class="text-center mx-sm-10 pt-0 pt-sm-4"
      :dense="$vuetify.breakpoint.xs"
    >
      <v-timeline-item
        v-for="session in tutorSessions"
        :key="session.group"
        :color="getColorBaseOnCap(session)"
        small
      >
        <v-card class="mr-3 mb-3">
          <v-card-text class="pb-3 px-sm-5">
            <div class="text-overline text--primary font-weight-medium">
              {{ formatDate(session.date) }}
            </div>
            <div class="text-caption">
              {{ formatStatus(session.status) }}
            </div>

            <v-btn
              small
              text
              color="tertiary"
              class="mt-2 px-2"
              @click="toTutorialView(session)"
            >
              Mehr
            </v-btn>
          </v-card-text>
        </v-card>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
import { defineComponent, ref } from "@vue/composition-api";

export default defineComponent({
  name: "TimeLine",
  props: {
    tutorSessions: ref([]),
  },
  setup(props, { root }) {
    const toTutorialView = (session) => {
      const routeData = root.$router.resolve({
        name: "tutorials.id",
        params: {
          sessionId: session.id.toString(),
          capacity: session.tutorial.capacity,
          room: session.tutorial.room,
          tutorialId: session.tutorial.id,
        },
      });
      window.open(routeData.href, "_blank");
    };
    const getColorBaseOnCap = (session) => {
      console.log(session);
      if (!session) return "#3D82AF";
      if (!session.tutorial) return "#3D82AF";
      const capacity = session.tutorial.capacity;
      const status = session.status;

      if (status === "PLANED") {
        if (capacity === "NOT_CROWDED") {
          return "#64A0C8";
        } else if (capacity === "NORMAL") {
          return "#3D82AF";
        } else if (capacity === "CROWDED") {
          return "#2D5E7F";
        } else if (capacity === "BUSY") {
          return "#22475F";
        } else {
          return "#3D82AF";
        }
      } else if (status === "MODIFIED") {
        return "#E99A27";
      } else if (status === "CANCELED") {
        return "#E47B73";
      } else {
        return "#3D82AF";
      }
    };
    return {
      toTutorialView,
      getColorBaseOnCap,
    };
  },
  methods: {
    formatDate(d) {
      const dayParts = d.split("-");
      if (dayParts.length >= 3) {
        return dayParts[2] + "." + dayParts[1] + "." + dayParts[0];
      }
      return d;
    },
    formatStatus(s) {
      if (s === "PLANED") {
        return "geplant";
      } else if (s === "MODIFIED") {
        return "modifiziert";
      } else if (s === "CANCELED") {
        return "abgesagt";
      } else {
        return "";
      }
    },
  },
  data: function () {
    return {
      notCrowded: "#64A0C8",
      normal: "#3D82AF",
      crowded: "#2D5E7F",
      busy: "#22475F",
      modified: "#E99A27",
      cancelled: "#E47B73",
    };
  },
});
</script>

<style scoped>
*,
*::before,
*::after {
  box-sizing: border-box;
}

.content {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}

body {
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
  background: #ffffff;
}

.timeline {
  position: relative;
  width: 100%;
  max-width: 1140px;
  margin: 0 auto;
  padding: 15px 0;
}

.timeline::after {
  content: "";
  position: absolute;
  width: 2px;
  background: #006e51;
  top: 0;
  bottom: 0;
  left: 50%;
  margin-left: -1px;
}

button {
  background-color: transparent;
}

.v-timeline-item {
  padding-bottom: 0;
}
</style>
